module.exports = __webpack_public_path__ + "img/map.c45978c6.png";